<template>
    <div class="header row d-block d-md-none">
      <div class="text-right">
        <button aria-label="Close Filter Menu" class="close-btn-mobile" tabindex="0" @click="onClose">
          Apply filters and close
        </button>
      </div>
    </div>
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    onClose() {
      this.$store.commit('search/setShowFilterOnMobile', false)
      document.getElementById("toggle-filter-button").focus();
    },
  },
}
</script>

<style scoped>
.close-btn-mobile {
  background: #ddd;
  color: #193e72;
  outline: 0;
  cursor: pointer;
  border-radius: 8px;
  font-weight: 700 !important;
  white-space: nowrap;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  margin-bottom: 0.5rem !important;
  padding-top: 0.4rem !important;
  padding-bottom: 0.4rem !important;
  margin-top: 0.5rem !important;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  width: 60%;
  min-height: 1px;
  font: inherit;
  margin-right: 20%;
}

.close-btn-mobile:focus {
  box-shadow: 0 0 0 4px #ea5d4e;
  /* outline: 3px solid #FED47A; */
}
</style>
